<template>
  <div class="modal-card">
    <header class="modal-card-head">
      <p class="modal-card-title">{{ title }}</p>
      <button
        v-if="showCloseButton"
        type="button"
        class="delete"
        @click="$emit('close')"
      />
    </header>

    <section class="modal-card-body">
      <p v-html="content"></p>
    </section>

    <footer class="modal-card-foot is-borderless">
      <a
        v-if="confirmButton"
        class="button is-link is-text-primary is-borderless"
        type="button"
        @click="
          () => {
            $emit('close');
            $emit('confirm');
          }
        "
      >
        {{ confirmButtonText }}
      </a>

      <button
        v-if="cancelButton"
        class="button is-primary is-rounded"
        @click="
          () => {
            $emit('close');
            $emit('cancel');
          }
        "
      >
        {{ cancelButtonText }}
      </button>
    </footer>
  </div>
</template>

<script lang="ts">
import { Component, Vue, Prop } from 'vue-property-decorator';

@Component({
  components: {},
})
export default class BaseDialog extends Vue {
  @Prop({ default: '' })
  public title!: string;

  @Prop({ default: '' })
  public content!: string;

  @Prop({ default: 'Remove' })
  public confirmButtonText!: string;

  @Prop({ default: true })
  public confirmButton!: boolean;

  @Prop({ default: 'Cancel' })
  public cancelButtonText!: string;

  @Prop({ default: true })
  public cancelButton!: boolean;

  @Prop({ default: true })
  public showCloseButton!: boolean;

  @Prop({ type: Boolean, default: false })
  public isUnsavedChangesConfirmationDialog!: boolean;

  public mounted() {
    if (this.isUnsavedChangesConfirmationDialog) {
      this.$store.dispatch(
        'unsavedChangesGuard/setUnsavedChangesDialogActive',
        true,
      );
    }
  }

  public beforeDestroy(): void {
    if (this.isUnsavedChangesConfirmationDialog) {
      // Dispatch the corresponding action to set the flag to false when the dialog is closed.
      this.$store.dispatch(
        'unsavedChangesGuard/setUnsavedChangesDialogActive',
        false,
      );
    }
  }
}
</script>
